export const FIAT = 'fiat';
export const CRYPTO = 'crypto';
